{
    "page_header": {
        "title": "Features For Shoppers",
        "subtitle": "Smart Shopping Simplified\r\nAt Receeto, we believe in enhancing your shopping journey by introducing a seamless, digital receipt experience.",
        "image": null
    },
    "sections": [
        {
            "section_id": "shoppers_features",
            "title": null,
            "subtitle": "",
            "image": null,
            "articleLists": [
                {
                    "id": 10,
                    "title": null,
                    "articles": [
                        {
                            "id": 11,
                            "title": "Instant Digital Receipts",
                            "subtitle": "",
                            "description": "Say goodbye to paper receipts! With Receeto, your purchase receipts are instantly digitized, accessible at your fingertips, and neatly organized in one place.As well as, by opting for digital receipts, you actively participate in eco-friendly shopping practices.",
                            "image": "https://receeto.com/assets/fake-db/images/shopper_feature_01.webp"
                        },
                        {
                            "id": 12,
                            "title": "Personalized Offers and Recommendations",
                            "subtitle": "",
                            "description": "Enjoy personalized offers and product recommendations based on your shopping preferences and behavior. Our intelligent system ensures you receive deals tailored just for you.",
                            "image": "https://receeto.com/assets/fake-db/images/shopper_feature_02.webp"
                        },
                        {
                            "id": 13,
                            "title": "Streamlined Returns and Exchanges",
                            "subtitle": "",
                            "description": "No more worries about losing paper receipts. Receeto makes returns and exchanges easy by providing quick access to your digital receipts, making the process smoother for you.",
                            "image": "https://receeto.com/assets/fake-db/images/shopper_feature_03.webp"
                        }
                    ]
                }
            ]
        },
        {
            "section_id": "shoppers_pricing",
            "title": "Pricing",
            "subtitle": "Enhance your shopping experience now\r\nselect your plan and embrace smarter, sustainable shopping with Receeto!",
            "image": null,
            "articleLists": [
                {
                    "id": 11,
                    "title": null,
                    "articles": [
                        {
                            "id": 2,
                            "title": "Get It For Free Now !",
                            "subtitle": null,
                            "description": "90% of our features are FREE! but if you are a shopping monster you can subscribe for daily advanced fonctionnalities."
                        }
                    ]
                }
            ]
        },
        {
            "section_id": "shoppers_compare_table",
            "title": "Compare Pricing Packages",
            "subtitle": "",
            "image": null
        }
    ],
    "banners": [
        {
            "id": 3,
            "banner_id": "shoppers_sub_banner_01",
            "title": "Get Your Receeto Now",
            "subtitle": "Enhance your shopping journey",
            "description": "Subscribe now to our newsletter to be the first one informed about our updates.",
            "image": "https://receeto.com/assets/fake-db/images/shopper_sub_banner.webp"
        }
    ],
    "payment_methods": [
        {
            "logo": "https://receeto.com/assets/fake-db/images/visa.webp"
        },
        {
            "logo": "https://receeto.com/assets/fake-db/images/mastercard.webp"
        },
        {
            "logo": "https://receeto.com/assets/fake-db/images/paypal.webp"
        },
        {
            "logo": "https://receeto.com/assets/fake-db/images/amazon.webp"
        }
    ],
    "plans": [
        {
            "id": 1,
            "plan_id": "shoppers_plan_01",
            "price_per_month": "Free",
            "description": "90% Free",
            "name": "Basic",
            "table_note": "90% free",
            "is_best_deal": false,
            "key_features": "<ul>\r\n<li class=\"ng-star-inserted\">Digital Receipts</li>\r\n<li class=\"ng-star-inserted\">Expense Tracking</li>\r\n<li class=\"ng-star-inserted\">Access To Offers</li>\r\n<li class=\"ng-star-inserted\">Traditional Receipt Scanning</li>\r\n<li class=\"ng-star-inserted\">Security and Privacy</li>\r\n</ul>"
        },
        {
            "id": 2,
            "plan_id": "shoppers_plan_02",
            "price_per_month": "Dannous",
            "description": "If billed annually, otherwise 1.2 TND / month",
            "name": "Prestigious",
            "table_note": "Dannous / month",
            "is_best_deal": true,
            "key_features": "<ul>\r\n<li class=\"ng-star-inserted\" style=\"color: #7857e6;\"><span style=\"color: #7857e6;\">Basic Plan Plus...</span></li>\r\n<li class=\"ng-star-inserted\">Professional use</li>\r\n<li class=\"ng-star-inserted\">Analytics</li>\r\n<li class=\"ng-star-inserted\">Bugeting</li>\r\n<li class=\"ng-star-inserted\">Paiement integrations</li>\r\n<li class=\"ng-star-inserted\">Financial Goal Tracking</li>\r\n<li class=\"ng-star-inserted\">Multi-format (CSV,PDF) Transactions</li>\r\n<li class=\"ng-star-inserted\">Exporting</li>\r\n</ul>"
        }
    ],
    "feature_groups": [
        {
            "id": 1,
            "title": "Receipt Management",
            "features": [
                {
                    "id": 1,
                    "content": "<p>Digital Receipts</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                },
                {
                    "id": 2,
                    "content": "<p>Offline Access</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                },
                {
                    "id": 3,
                    "content": "<p>Receipt Organization</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                }
            ]
        },
        {
            "id": 2,
            "title": "Expenses Management",
            "features": [
                {
                    "id": 4,
                    "content": "<p>Expense Tracking</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                },
                {
                    "id": 5,
                    "content": "<p>Budgeting</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                },
                {
                    "id": 6,
                    "content": "<p>Analytics</p>",
                    "is_active_in": [
                        2
                    ]
                },
                {
                    "id": 7,
                    "content": "<p>Financial Insights</p>",
                    "is_active_in": [
                        2
                    ]
                }
            ]
        },
        {
            "id": 3,
            "title": "Loyalty Features",
            "features": [
                {
                    "id": 8,
                    "content": "<p>Access to Offers</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                },
                {
                    "id": 9,
                    "content": "<p>Notification Alerts</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                },
                {
                    "id": 10,
                    "content": "<p>Access to Loyalty programs</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                }
            ]
        },
        {
            "id": 4,
            "title": "Integration and Accessibility",
            "features": [
                {
                    "id": 11,
                    "content": "<p>Traditional Receipt Scanning</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                },
                {
                    "id": 12,
                    "content": "<p>Integration With Payement Solutions</p>",
                    "is_active_in": [
                        2
                    ]
                }
            ]
        },
        {
            "id": 5,
            "title": "Expense Insights",
            "features": [
                {
                    "id": 13,
                    "content": "<p>Spending Patterns</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                },
                {
                    "id": 14,
                    "content": "<p>Financial Goal Tracking</p>",
                    "is_active_in": [
                        2
                    ]
                }
            ]
        },
        {
            "id": 6,
            "title": "Security and Privacy",
            "features": [
                {
                    "id": 15,
                    "content": "<p>Data Encryption</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                },
                {
                    "id": 16,
                    "content": "<p>Privacy Controls</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                }
            ]
        },
        {
            "id": 7,
            "title": "Support and Assistance",
            "features": [
                {
                    "id": 17,
                    "content": "<p>Customer Support</p>",
                    "is_active_in": [
                        1,
                        2
                    ]
                }
            ]
        }
    ]
}